import type { ComboBoxOption } from 'components/DesignSystems/New/StylishNewComboBox';

export const OBJECTIVES_LIBRARY: ComboBoxOption[] = [
  {
    value: 'increase-sector-columbia-rivers-border',
    label:
      "Increase Sector Columbia River's Border Security & Territorial Integrity operational presence.",
  },
  {
    value: 'enhance-operational-coordination-with-federal',
    label:
      'Enhance operational coordination with federal, state, and local partners.',
  },
  {
    value: 'leverage-intelligence-collection-analysis-and',
    label:
      'Leverage intelligence collection, analysis, and sharing within District 13.',
  },
  {
    value: 'establish-and-or-increase-use',
    label: 'Establish and/or increase use of Title 19 boarding authorities.',
  },
  {
    value: 'increase-targeted-multi-agency-strike-force',
    label:
      'Increase targeted Multi-Agency Strike Force operations (MASFOs) by 100% annually.',
  },
  {
    value: 'ensure-full-access-to-the',
    label:
      'Ensure full access to the container on 25% of required container inspections.',
  },
  {
    value: 'conduct-25-of-annual-mtsa',
    label:
      'Conduct 25% of annual MTSA facility security spot check inspections outside of standard workday.',
  },
  {
    value: 'conduct-a-minimum-of-one',
    label:
      'Conduct a minimum of one observation of bulk/breakbulk discharge per quarter.',
  },
  {
    value: 'conduct-cg-cyber-command-missions',
    label:
      'Conduct CG Cyber Command missions across domestic port infrastructure.',
  },
];

export const STRATEGIES_LIBRARY: ComboBoxOption[] = [
  {
    value: 'increase-presence-through-targeted-patrols',
    label:
      'Increase presence through targeted patrols, rapid-response small boat deployments, and expanded hours for boarding teams.',
  },
  {
    value: 'leverage-title-19-boardings-svsbs',
    label:
      'Leverage title 19 boardings, SVSBs, and interagency patrols with CBP to maximize detection and deterrence.',
  },
  {
    value: 'conduct-intel-briefs-to-align-ops',
    label:
      'Conduct intel briefs to align ops with known fentanyl trafficking trends.',
  },
  {
    value: 'leverage-recom-meetings-and-syncs',
    label:
      'Leverage RECOM meetings and syncs with CBP, FBI, DEA, and local LE partners to align border security efforts.',
  },
  {
    value: 'co-plan-and-execute-joint-ops',
    label: 'Co-plan and execute joint ops.',
  },
  {
    value: 'expand-intel-collections-through-post-boarding',
    label:
      'Expand intel collections through post-boarding (to include Post-SAR) debriefs and suspicious activity reporting.',
  },
  {
    value: 'utilize-products-provided-by-the',
    label:
      'Utilize products provided by the intelligence community to inform operations.',
  },
  {
    value: 'conduct-regular-intel-syncs-with',
    label:
      'Conduct regular intel syncs with D13 to align targeting priorities.',
  },
  {
    value: 'push-out-threat-advisories-to',
    label: 'Push out threat advisories to applicable working groups.',
  },
  {
    value: 'train-and-certify-personnel-in-title',
    label:
      'Train and certify personnel in title 19 authority to expand qualified boarding capabilities.',
  },
  {
    value: 'prioritize-increased-security-boardings-to-include',
    label:
      'Prioritize increased security boardings to include SVSBs and abbreviated LMR boardings during routine patrols and operations.',
  },
  {
    value: 'incorporate-title-19-use-into',
    label:
      'Incorporate Title 19 use into patrol planning to ensure consistent legal coverage for BSTI enforcement actions.',
  },
  {
    value: 'develop-a-masfo-op-calendar',
    label:
      'Develop a MASFO op calendar and align with CBP and DEA to ID high-risk vessel arrivals.',
  },
  {
    value: 'coordinate-container-screening-and-inspection-efforts',
    label:
      'Coordinate container screening and inspection efforts using risk-based targeting.',
  },
  {
    value: 'incorporate-k9-units-x-ray',
    label:
      'Incorporate K9 units, x ray scans, and intel cues to prioritize container selection and ensure layered enforcement at terminals.',
  },
  {
    value: 'coordinate-w-terminal-ops-and',
    label:
      'Coordinate w/ terminal ops and shipping lines to ensure containing doors are accessible and available for opening.',
  },
  {
    value: 'pre-identify-inspection-candidates-with-cbp',
    label:
      'Pre-identify inspection candidates with CBP and use joint scheduling to increase access likelihood.',
  },
  {
    value: 'maintain-documentation-of-denied-access-cases',
    label:
      'Maintain documentation of denied access cases to support enforcement or follow-up inspections.',
  },
  {
    value: 'schedule-off-hours-spot-checks-during',
    label:
      'Schedule off-hours spot checks during nights, weekends to assess true security posture.',
  },
  {
    value: 'coordinate-with-fac-security-officers-to',
    label:
      'Coordinate with fac security officers to ensure access and minimize disruptions.',
  },
  {
    value: 'track-inspection-timing-in-misle-to',
    label:
      'Track inspection timing in MISLE to ensure annual target is met and trend fac compliance during off-peak hours.',
  },
  {
    value: 'increase-uscg-presence-during-shipment-transfers',
    label:
      'Increase USCG presence during shipment transfers by observing transfer operations.',
  },
  {
    value: 'identify-and-target-bulk-breakbulk-discharges',
    label:
      'Identify and target bulk/breakbulk discharges for observation to disrupt transshipments of illicit drugs (ALCOAST 39/25).',
  },
  {
    value: 'coordinate-with-cgcyber-to-schedule-cpt',
    label:
      'Coordinate with CGCYBER to schedule CPT missions at high-risk MTSA-regulated facilities.',
  },
  {
    value: 'id-willing-commercial-entities-through-outreach',
    label:
      'ID willing commercial entities through outreach and partnership engagement.',
  },
  {
    value: 'facilities-pre-survey-coordination-to-ensure',
    label:
      'Facilities pre-survey coordination to ensure access and provide CPT w/ facility specific context to enhance assessment value.',
  },
];

export const TACTICS_LIBRARY: ComboBoxOption[] = [
  {
    value: 'cargo-transfer-container-inspections-after-hours-inspections',
    label:
      'Cargo Transfer, Container Inspections, After-Hours Inspections, Security Boarding, Ashore, & Station Groups: Conduct increased water & ashore patrols and boardings to include after-hours to disrupt fentanyl smuggling ops.',
  },
  {
    value: 'coordinate-targeted-boardings-of-opportunities-to',
    label:
      'Coordinate targeted boardings of opportunities to include SVSBs in the Columbia River and assert fed authority under Title 19 through Targeting group.',
  },
  {
    value: 'cargo-transfer-group-enhanced-container-inspections',
    label:
      'Cargo Transfer Group & Enhanced Container inspections group/AH Inspecting group, Security Ashore Group: Sector Facilities, Intel, and Boarding teams will coordinate with CBP, DEA, local law enforcement to plan and execute MASFOs at Port of Portland and regional terminals.',
  },
  {
    value: 'targeting-group-compile-via-sector-intel',
    label:
      'Targeting Group: Compile via Sector intel & D13-collect, and analyze data, & distribute actionable advisories to the operations section groups to support identification and interdiction of fentanyl-related threats.',
  },
  {
    value: 'provide-security-boarding-and-station-operations',
    label:
      'Provide Security boarding and station operations groups (sub-unit stations) with actionable vessel targeting intel or indicators for decisional action by the operations section.',
  },
  {
    value: 'stations-operations-security-boarding-group-conduct',
    label:
      'Stations Operations & Security Boarding Group: Conduct abbreviated LMR boardings and SVSBs.',
  },
  {
    value: 'scr-sbt-will-frequency-of-non-hiv',
    label:
      'SCR SBT will frequency of Non-HIV security boardings, SVSBs, and abbreviated LMR boardings of opportunity based on targeting information and opportunity.',
  },
  {
    value: 'stations-and-sbt-boardings-will-leverage',
    label:
      'Stations and SBT boardings will leverage Tittle 19 authority during patrols ISO BSTI as a priority area to expand interdiction capacity and enforce jurisdiction.',
  },
  {
    value: 'container-cargo-transfer-group-enhanced-inspections',
    label:
      'Container Cargo Transfer Group & Enhanced inspections group/AH Inspecting group, Security Ashore Group: Sector staff to coordinate with CBP, DEA, and port stakeholders to conduct MASFOs at Port of Portland, targeting high-risk containers using joint inspection teams.',
  },
  {
    value: 'scr-sbt-to-conduct-training-with',
    label:
      'SCR SBT to conduct training with OGAs for familiarization of CBP systems and port ops security vetting procedures.',
  },
  {
    value: 'sector-inspections-and-cbp-officers',
    label:
      'Cargo Transfer Group & Enhanced Container inspections group/AH Inspecting group: Sector Inspections and CBP Officers will jointly inspect targeted containers at Port of Portland, ensuring full access on at least 25% of all required inspections to enhance contraband detection and support BSTI enforcement objectives.',
  },
  {
    value: 'scr-sbt-to-join-and-accompany',
    label: 'SCR SBT to join and accompany inspections upon opportunity.',
  },
  {
    value: 'after-hours-inspecting-group-sector-fac',
    label:
      'After Hours Inspecting group: Sector FAC inspectors and SBT will conduct unannounced fac spot checks of opportunity during nights and weekends at regulated terminals to verify compliance during off peak ops, ensuring at least 25% of annual checks occur outside normal business hours.',
  },
  {
    value: 'reservist-will-be-sought-to-be',
    label: 'Reservist will be sought to be utilized to help complete.',
  },
  {
    value: 'targeting-group-cargo-transfer-monitoring-group',
    label:
      "Targeting Group/ Cargo Transfer Monitoring group: Sector's DMI/AMI will observe at least one bulk or breakbulk cargo discharge per quarter on targeted transfers within AOR.",
  },
  {
    value: 'create-transfer-targeting-system-in-collaboration',
    label: 'Create transfer targeting system in collaboration with intel.',
  },
  {
    value: 'dom-branch-chief-will-work-with',
    label:
      'DOM branch chief will work with duty teams to ensure completion each quarter.',
  },
  {
    value: 'cyber-protection-group-sector-cyber',
    label:
      'Cyber protection group: Sector Cyber Liaison and CGCYBER CPT will coordinate with facilities to conduct cyber vulnerability surveys, targeting key commercial entities and infrastructure nodes to assess and enhance port cybersecurity posture.',
  },
];
